import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=391f5b3a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391f5b3a')) {
      api.createRecord('391f5b3a', component.options)
    } else {
      api.reload('391f5b3a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=391f5b3a&", function () {
      api.rerender('391f5b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/pricehelp.vue"
export default component.exports